import { render, staticRenderFns } from "./MyClient.vue?vue&type=template&id=5af5d1d9&scoped=true&"
import script from "./MyClient.vue?vue&type=script&lang=js&"
export * from "./MyClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5d1d9",
  null
  
)

export default component.exports